import { CardSheet, type CardSheetConfig } from '../components/CardSheet';
import { hrApi } from '../lib/hrApi';

/**
 * Staff ID cards — the same sheet as the student one, with a different face.
 */
const config: CardSheetConfig = {
  eyebrow: 'Staff',
  title: 'Staff ID cards',
  intro: (
    <>
      The same 85.6 × 54 mm card as the student sheet. Shows the designation, blood group and the
      emergency contact's number — not a date of birth.
    </>
  ),
  path: '/api/staff/id-cards',
  groupParam: 'departmentId',
  groupLabel: 'Department',
  // ⚠ NOT REQUIRED, unlike the student sheet. A school has forty staff and one sheet of nine;
  // "everyone" is the normal request, and making them pick a department first would be a step
  // invented to satisfy the shape of another screen.
  groupRequired: false,
  allLabel: 'Everyone on the staff',
  loadGroups: async () => (await hrApi.listDepartments())
    .filter((d) => d.isActive)
    // ⚠ No count — the departments endpoint does not carry one, and CardGroup makes it optional so
    // the picker shows the name alone rather than "· 0" beside every department.
    .map((d) => ({ id: d.id, label: d.name })),
  emptyHint: (
    <>
      Press <strong>Build the sheet</strong> for everyone, or pick a department first. Staff without
      a photograph still get a card, with a space to add one later.
    </>
  ),
};

export function StaffIdCardsPage() {
  return <CardSheet config={config} />;
}
